/**
 * Minimal i18n for viewer app
 * Supports Chinese (zh) and English (en)
 */

const translations = {
  en: {
    loading: 'Loading session...',
    sessionNotFound: 'Session not found',
    loadFailed: 'Failed to load session',
    goBack: 'Go back',
    clearSession: 'Clear session',
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
    uploadTitle: 'XClaw Session Viewer',
    uploadDescription: 'Drop a session JSON file here, or click to browse',
    uploadButton: 'Select File',
    uploadDragHint: 'Drop session file here',
    invalidFile: 'Invalid session file format',
    poweredBy: 'Powered by XClaw',
    langSwitch: '中文',
  },
  zh: {
    loading: '加载会话中...',
    sessionNotFound: '会话未找到',
    loadFailed: '加载会话失败',
    goBack: '返回',
    clearSession: '清除会话',
    switchToLight: '切换至浅色模式',
    switchToDark: '切换至深色模式',
    uploadTitle: 'XClaw 会话查看器',
    uploadDescription: '拖放会话 JSON 文件到这里，或点击浏览',
    uploadButton: '选择文件',
    uploadDragHint: '拖放会话文件到这里',
    invalidFile: '无效的会话文件格式',
    poweredBy: '由 XClaw 提供支持',
    langSwitch: 'EN',
  },
} as const

export type Locale = keyof typeof translations
export type TranslationKey = keyof typeof translations['en']

/** Detect browser language, default to English */
export function detectLocale(): Locale {
  const lang = navigator.language?.toLowerCase() || ''
  if (lang.startsWith('zh')) return 'zh'
  return 'en'
}

export function t(locale: Locale, key: TranslationKey): string {
  return translations[locale]?.[key] ?? translations.en[key] ?? key
}
